import client from "services/api/client";
import MockAdapter from "axios-mock-adapter";
import {BASE_API_URL} from "constants.js";
import {ENDPOINTS} from "services/api/index";
import {ProfileEditFormBaseState} from "features/forms/profile-edit";
import {LocalStorageService} from "services/utils/local-storage-service";
import {Profile} from "mapping/profile";
import {Company} from "mapping/company";
import {CompanyUpsertFormBaseState} from "features/forms/company-upsert";
import {ADMIN_ROLE_KEY} from "constants.js";
import {flattenDeep, intersection, keyBy} from "lodash";

const _endpoint = (endpoint) => BASE_API_URL+endpoint;
const _buildError = (error, status) => { return [status, {errors: [error]}] }

const CACHE_KEY = "MOCK_CACHE_KEY";

const saveCache = () => {
    LocalStorageService.setItem(CACHE_KEY, JSON.stringify(cache));
    console.log("saved cache", cache);
}

const profileServerLike = (profile) => {
    return Profile.toServer(profile)
}
const companyServerLike = (company) => {
    return Company.toServer(company)
}

const common_video = {
    description: "Questo testo è da fare e qui trovi un esempio di blocco di testo di qualche riga per fare “tampone” nell’attesa del copywriter che se ne prenda cura.",
    speakers: [{title: "Speaker", name: "Mario Rossi", avatar: "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg", role: "CEO", company:"Azienda S.r.l"}],
    material: [{type: "link", title: "Facebook", name: "www.facebook.com", link: "http://facebook.com"}, {type: "download", title: "Dispensa", name: "dispensa.pdf", link: "http://facebook.com"}],
    video_id: "129243574",
    progress: 0,
    duration: 132,
    likes: {
        total: 10,
        avatars: ["https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg", "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg"]
    },
    like: false
}
const common_events = {
    description: "Questo testo è da fare e qui trovi un esempio di blocco di testo di qualche riga per fare “tampone” nell’attesa del copywriter che se ne prenda cura.",
    speakers: [{title: "Speaker", name: "Mario Rossi", avatar: "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg", role: "CEO", company:"Azienda S.r.l"}],
    likes: {
        total: 5,
        avatars: ["https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg", "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg"]
    },
    like: false
}

const usersToSearch = [
    {
        id: 1,
        first_name: "Luca",
        last_name: "Test",
        slug: "test-1"
    },
    {
        id: 2,
        first_name: "Francesco",
        last_name: "Test",
        slug: "test-2"
    },
    {
        id: 3,
        first_name: "Luca",
        last_name: "Suggest",
        slug: "test-3"
    },
    {
        id: 4,
        first_name: "Matteo",
        last_name: "Somethingelse",
        slug: "test-4"
    }
];

let initial_cache = {
    profile: {
        ...profileServerLike(ProfileEditFormBaseState)
    },
    companies: [
        companyServerLike({
            ...CompanyUpsertFormBaseState,
            id: -1,
            role: ADMIN_ROLE_KEY,
            name: "Admin Company",
            vat: "IT00000000000"
        })
    ],
    video: [{
        "video": {
            "id": 1,
            "title": "Primo Video di Prova",
            "url": "https://vimeo.com/129243574",
            "duration": 132,
            "description": "Lol 123",
            "cost": "15.00",
            "background": "https://media-cdn.tripadvisor.com/media/photo-s/10/3b/b1/a6/baita-panorama-hutte.jpg",
            "links": [{
                "link": "https://google.it",
                "name": "Nome del Link",
                "type": "link",
                "title": "Link 1",
                "row_id": "r6oyt0y2c"
            }],
            "created_at": "2020-07-09T19:16:23.000000Z",
            "updated_at": "2020-07-09T19:30:39.000000Z",
            "directory_id": 1,
            "is_published": 1,
            "sort_order": 1
        },
        "categories": ["asd", "lol", "kek"],
        "tags": ["tag1", "tag2", "tag3"],
        "speakers": [{
            "title": "Speaker",
            "avatar": "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg",
            "name": "Francesco Malatesta",
            "company": "Azienda Wow",
            "role": "Bla Bla"
        }],
        "lastLikesAvatars": ["https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg"],
        "likes": 0,
        "favorites": 0,
        "user_stats": {
            "id": 1,
            "user_id": 1,
            "video_id": 1,
            "liked": false,
            "favorite": false,
            "finished": false,
            "current": 0,
            "created_at": "2020-07-09T19:17:47.000000Z",
            "updated_at": "2020-07-09T19:17:47.000000Z"
        },
        "directory": null,
        "unlocked": {
            "plan": "osa-digital",
            "status": true
        }
    },
        {
            "video": {
                "id": 3,
                "title": "Terzo Video di Prova",
                "url": "https://vimeo.com/129243574",
                "duration": 50,
                "description": "Lol 123",
                "cost": "15.00",
                "background": "https://media-cdn.tripadvisor.com/media/photo-s/10/3b/b1/a6/baita-panorama-hutte.jpg",
                "links": [{
                    "link": "https://google.it",
                    "name": "Nome del Link",
                    "type": "link",
                    "title": "Link 1",
                    "row_id": "r6oyt0y2c"
                }],
                "created_at": "2020-07-09T19:16:23.000000Z",
                "updated_at": "2020-07-09T19:30:39.000000Z",
                "directory_id": 1,
                "is_published": 1,
                "sort_order": 1
            },
            "categories": ["asd", "lol", "kek"],
            "tags": ["tag1", "tag2", "tag3"],
            "speakers": [{
                "title": "Speaker",
                "avatar": "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg",
                "name": "Francesco Malatesta",
                "company": "Azienda Wow",
                "role": "Bla Bla"
            }],
            "lastLikesAvatars": ["https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg"],
            "likes": 0,
            "favorites": 0,
            "user_stats": {
                "id": 1,
                "user_id": 1,
                "video_id": 1,
                "liked": false,
                "favorite": false,
                "finished": false,
                "current": 0,
                "created_at": "2020-07-09T19:17:47.000000Z",
                "updated_at": "2020-07-09T19:17:47.000000Z"
            },
            "directory": null,
            "unlocked": {
                "plan": "osa-digital",
                "status": false
            }
        }],
    directories: [
        {
            "directory": {
                "id": 1,
                "title": "Corso di Nulla Cosmico",
                "description": "Lorem ipsum...",
                "image": "https://media-cdn.tripadvisor.com/media/photo-s/10/3b/b1/a6/baita-panorama-hutte.jpg",
                "cost": "18.00",
                "links": [],
                "created_at": "2020-07-09T19:30:23.000000Z",
                "updated_at": "2020-07-09T19:30:23.000000Z",
                "is_published": 1
            },
            "videos": [{
                "video": {
                    "id": 2,
                    "title": "Primo Video di Prova",
                    "url": "https://vimeo.com/12341234",
                    "duration": 50,
                    "description": "Lol 123",
                    "cost": "15.00",
                    "background": "https://media-cdn.tripadvisor.com/media/photo-s/10/3b/b1/a6/baita-panorama-hutte.jpg",
                    "links": [{
                        "link": "https://google.it",
                        "name": "Nome del Link",
                        "type": "link",
                        "title": "Link 1",
                        "row_id": "r6oyt0y2c"
                    }],
                    "created_at": "2020-07-09T19:16:23.000000Z",
                    "updated_at": "2020-07-09T19:30:39.000000Z",
                    "directory_id": 1,
                    "is_published": 1,
                    "sort_order": 1
                },
                "categories": ["asd", "lol", "kek"],
                "tags": ["tag1", "tag2", "tag3"],
                "speakers": [{
                    "title": "Speaker",
                    "avatar": "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg",
                    "name": "Francesco Malatesta",
                    "company": "Azienda Wow",
                    "role": "Bla Bla"
                }],
                "lastLikesAvatars": ["https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg"],
                "likes": 0,
                "favorites": 0,
                "user_stats": {
                    "id": 1,
                    "user_id": 1,
                    "video_id": 1,
                    "liked": false,
                    "favorite": false,
                    "finished": false,
                    "current": 0,
                    "created_at": "2020-07-09T19:17:47.000000Z",
                    "updated_at": "2020-07-09T19:17:47.000000Z"
                },
                "directory": null,
                "unlocked": {
                    "plan": "osa-digital",
                    "status": true
                }
            }],
            "categories": [],
            "tags": ["tag2", "tag3", "tag"],
            "authors": [],
            "unlocked": {
                "plan": "osa-digital",
                "status": true
            }
        }
    ],
    events: [
        {
            id: 1,
            categories: ["Grafica"],
            tags: ["tag1", "tag2"],
            requires_payment: false,
            cost: null,
            favorite: false,
            title: "Event title 1",
            image: "https://media-cdn.tripadvisor.com/media/photo-s/10/3b/b1/a6/baita-panorama-hutte.jpg",
            start_date: "2020-08-01T10:00:00.000000Z",
            end_date: "2020-08-01T13:00:00.000000Z",
            type: "online",
            location: "Webinar Zoom",
            tickets_available: 100,
            ...common_events
        },
        {
            id: 2,
            categories: ["Grafica"],
            tags: ["tag1", "tag2"],
            requires_payment: false,
            cost: null,
            favorite: false,
            title: "Event title 2",
            image: "https://media-cdn.tripadvisor.com/media/photo-s/10/3b/b1/a6/baita-panorama-hutte.jpg",
            start_date: "2020-08-01T10:00:00.000000Z",
            end_date: "2020-08-01T13:00:00.000000Z",
            type: "online",
            location: "Webinar Zoom",
            tickets_available: 0,
            ...common_events
        },
        {
            id: 3,
            categories: ["Grafica"],
            tags: ["tag1", "tag2"],
            requires_payment: true,
            cost: 10,
            favorite: false,
            title: "Event title 2",
            image: "https://media-cdn.tripadvisor.com/media/photo-s/10/3b/b1/a6/baita-panorama-hutte.jpg",
            start_date: "2020-06-01T10:00:00.000000Z",
            end_date: "2020-06-02T13:00:00.000000Z",
            type: "online",
            location: "Webinar Zoom",
            tickets_available: 40,
            ...common_events,
            videos: [
                {
                    id: 12,
                    title: "Video title 12",
                    tags: ["Design"],
                    created_at: "2020-06-25T07:47:15.000000Z",
                    favorite: false,
                    requires_payment: true,
                    cost: 5,
                    categories: ["Grafica"],
                    recently_viewed: true,
                    image: "https://media-cdn.tripadvisor.com/media/photo-s/10/3b/b1/a6/baita-panorama-hutte.jpg",
                    ...common_video
                },
                {
                    id: 13,
                    title: "Video title 13",
                    tags: ["Design"],
                    created_at: "2020-06-25T07:47:15.000000Z",
                    favorite: false,
                    requires_payment: true,
                    cost: 5,
                    categories: ["Grafica"],
                    recently_viewed: true,
                    image: "https://media-cdn.tripadvisor.com/media/photo-s/10/3b/b1/a6/baita-panorama-hutte.jpg",
                    ...common_video
                }
            ]
        }
    ],
    comments: {
        video: {},
        events: {}
    }
};

let cache = {
    ...initial_cache
}

const loadCache = () => {
    cache = {
        ...initial_cache,
        ...cache,
        ...JSON.parse(LocalStorageService.getItem(CACHE_KEY)),
    };
    saveCache();
    console.log("loaded cache", cache);
};

export const resetCache = () => {
    cache = {
        ...initial_cache
    };
    saveCache();
}

/* istanbul ignore file */
export function createMocks(errorEnabled = false) {
    console.log("Setting up mocks");
    loadCache();
    let delay = 1000;
    let mock = new MockAdapter(client, { delayResponse: delay });

    if(errorEnabled) {
        mock.onPost(_endpoint(ENDPOINTS.FORGOT_PASSWORD)).replyOnce(() => {
            return _buildError("Internal server error", 500);
        });
    }

    mock.onPost(_endpoint(ENDPOINTS.FORGOT_PASSWORD)).reply(204);
    if(errorEnabled) {
        mock.onPost(_endpoint(ENDPOINTS.LOGIN)).replyOnce(()=> _buildError("invalid_credentials", 403));
    }
    mock.onPost(_endpoint(ENDPOINTS.LOGIN)).replyOnce((config) => {
        const data = JSON.parse(config.data);
        cache.profile.email = data.email;
        saveCache();
        return [200, { temp_password: true, token: "my-good-token", onboarding_done: false }];
    }).onPost(_endpoint(ENDPOINTS.LOGIN)).reply(config => {
        const data = JSON.parse(config.data);
        cache.profile.email = data.email;
        saveCache();
        return [200, { temp_password: false, token: "my-good-token", onboarding_done: true }];
    });

    if(errorEnabled) {
        mock.onPost(_endpoint(ENDPOINTS.RESET_TEMP_PASSWORD)).replyOnce(()=> _buildError("internal_server_error", 500));
    }
    mock.onPost(_endpoint(ENDPOINTS.RESET_TEMP_PASSWORD)).reply(204);

    if(errorEnabled) {
        mock.onPost(_endpoint(ENDPOINTS.SIGNUP)).replyOnce(()=> _buildError("internal_server_error", 500));
    }
    mock.onPost(_endpoint(ENDPOINTS.SIGNUP)).reply(async (config) => {
        const data = JSON.parse(config.data);
        cache.profile.email = data.email;
        cache.profile.phone = data.phone;
        cache.profile.first_name = data.first_name;
        cache.profile.last_name = data.last_name;
        cache.profile.invoicing = data.invoicing;
        cache.profile.payment_methods = data.payment_methods;
        saveCache();
        return [200, { token: "my-good-after-signup-token" }];
    });
    mock.onGet(_endpoint(ENDPOINTS.PROFILE)).reply(200, {...cache.profile});

    mock.onPost(_endpoint(ENDPOINTS.PROFILE)).reply((config) => {
        cache.profile = serializeForm(config.data);
        saveCache();
        return [204];
    });

    mock.onGet(_endpoint(ENDPOINTS.COMPANIES)).reply(() => {
        return [200, cache.companies];
    });

    if(errorEnabled) {
        mock.onPost(_endpoint(`${ENDPOINTS.COMPANIES}${ENDPOINTS.ASSOCIATE}`)).replyOnce(() => _buildError("internal_server_error", 500));
    }
    mock.onPost(_endpoint(`${ENDPOINTS.COMPANIES}${ENDPOINTS.ASSOCIATE}`)).reply(config => {
        const data = JSON.parse(config.data);
        const company = {
            name: data.companyName,
            role: data.role,
            id: Math.floor(Math.random() * 10000)
        }
        cache.companies.push(companyServerLike(company));
        saveCache();
        return [204];
    });
    const deleteAssociationUrl = new RegExp(`${BASE_API_URL}${ENDPOINTS.COMPANIES}/[0-9]+${ENDPOINTS.ASSOCIATE}$`);
    if(errorEnabled) {
        mock.onDelete(deleteAssociationUrl).replyOnce(() => _buildError("internal_server_error", 500));
    }
    mock.onDelete(deleteAssociationUrl).reply(config => {
        const id = config.url.replace(ENDPOINTS.COMPANIES, "").replace(ENDPOINTS.ASSOCIATE, "").replace("/", "");
        cache.companies = cache.companies.filter(c => !(c.id.toString() === id.toString()));
        saveCache();
        return [204];
    });
    if(errorEnabled) {
        mock.onPost(_endpoint(ENDPOINTS.COMPANIES)).replyOnce(() => _buildError("internal_server_error", 500));
    }
    mock.onPost(_endpoint(ENDPOINTS.COMPANIES)).reply(async (config) => {
        const id = Math.floor(Math.random() * 10000);
        const company = serializeForm(config.data);
        company.role = ADMIN_ROLE_KEY;
        company.secret_code = "test-secret-code";
        company.associates = [{firstName: "Associato", lastName: "Uno", role: "collab", image: "", id: 1}, {firstName: "Associato", lastName: "Due", role: "collab", image: "", id: 2}];
        company.id = id;
        if(company.logo) {
            await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(company.logo);
                reader.onload = (event) => {
                    company.logo = {
                        name: company.logo.name,
                        type: company.logo.type,
                        src: event.target.result
                    }
                    resolve();
                }
            });
        }
        cache.companies.push(company);
        saveCache();
        return [204];
    });
    if(errorEnabled) {
        mock.onPut(_endpoint(ENDPOINTS.ONBOARDING_COMPLETE)).replyOnce(() => _buildError("internal_server_error", 500));
    }
    mock.onPut(_endpoint(ENDPOINTS.ONBOARDING_COMPLETE)).reply(204);

    const resetCodeCompanyUrl = new RegExp(`${BASE_API_URL}${ENDPOINTS.COMPANIES}/-?[0-9]+${ENDPOINTS.RESET_CODE}`);
    if(errorEnabled) {
        mock.onPut(resetCodeCompanyUrl).replyOnce(() => _buildError("internal_server_error", 500));
    }
    mock.onPut(resetCodeCompanyUrl).reply(config => {
        const id = config.url.replace(ENDPOINTS.COMPANIES, "").replace(ENDPOINTS.RESET_CODE, "").replace("/", "");
        const company = Company.fromServer(cache.companies.find(c => (c.id.toString() === id.toString())));
        const old_code = company.secretCode.split(":");
        company.secretCode = `${old_code[0]}:${old_code.length === 1 ? "1" : parseInt(old_code[1]) + 1}`
        const companies = cache.companies.filter(c => !(c.id.toString() === id.toString()));
        companies.push(companyServerLike(company));
        cache.companies = companies;
        saveCache();
        return [204]
    });

    const companyUpdateUrl = new RegExp(`${BASE_API_URL}${ENDPOINTS.COMPANIES}/-?[0-9]+$`);
    if(errorEnabled) {
        mock.onPut(companyUpdateUrl).replyOnce(() => _buildError("internal_server_error", 500));
    }
    mock.onPut(companyUpdateUrl).reply(async config => {
        const company = serializeForm(config.data);
        company.role = ADMIN_ROLE_KEY;
        company.secret_code = "test-secret-code";
        company.associates = [{firstName: "Associato", lastName: "Uno", role: "collab", image: "", id: 1}, {firstName: "Associato", lastName: "Due", role: "collab", image: "", id: 2}];
        cache.companies = cache.companies.filter(c => !(c.id.toString() === company.id.toString()));
        if(company.logo) {
            await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(company.logo);
                reader.onload = (event) => {
                    company.logo = {
                        name: company.logo.name,
                        type: company.logo.type,
                        src: event.target.result
                    }
                    resolve();
                }
            });
        }
        cache.companies.push(company)
        saveCache();
        return [204];
    });

    const deleteUserAssociationUrl = new RegExp(`${BASE_API_URL}${ENDPOINTS.COMPANIES}/-?[0-9]+${ENDPOINTS.ASSOCIATE}/[0-9]+$`);
    if(errorEnabled) {
        mock.onDelete(deleteUserAssociationUrl).replyOnce(() => _buildError("internal_server_error", 500));
    }
    mock.onDelete(deleteUserAssociationUrl).reply(config => {
        const ids = config.url.replace(ENDPOINTS.COMPANIES, "").replace(ENDPOINTS.ASSOCIATE, "").replace("/", "");
        const [companyId, userId] = ids.split("/");
        const company = Company.fromServer(cache.companies.find(c => (c.id.toString() === companyId.toString())));
        company.associates = company.associates.filter(a => a.id.toString() !== userId.toString());
        const companies = cache.companies.filter(c => !(c.id.toString() === companyId.toString()));
        companies.push(companyServerLike(company));
        cache.companies = companies;
        saveCache();
        return [204];
    });

    // STATIC DATA

    mock.onGet(_endpoint(ENDPOINTS.SKILLS)).reply(200, [
            {key: "strategy", value: "Strategia"},
            {key: "design", value: "Design"},
            {key: "test", value: "Test"},
            {key: "test2", value: "Test2"}
        ]);
    mock.onGet(_endpoint(ENDPOINTS.INTERESTS)).reply(200, [
            {key: "strategy", value: "Strategia"},
            {key: "design", value: "Design"},
            {key: "test", value: "Test"},
            {key: "test2", value: "Test2"}
        ]);


    /*HOME*/
    mock.onGet(_endpoint(ENDPOINTS.HOME_DATA)).reply(200, {
        videos: cache.video,
        recent_videos: cache.video.filter(i => i.recently_viewed),
        category_videos: {
            category: "Innovazione",
            list: cache.video.filter(i => (i.categories || []).includes("Innovazione"))
        },
        directories: cache.directories,
        events: cache.events
    });
    // Video Favorite
    const favoriteVideoEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_VIDEO}/-?[0-9]+${ENDPOINTS.FAVORITE}`);
    mock.onPut(favoriteVideoEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_VIDEO, "").replace(ENDPOINTS.FAVORITE, "").replace("/", "");
        const data = JSON.parse(config.data);
        const videos = keyBy(cache.video, "video.id");
        if(videos[id]) {
            videos[id].user_stats.favorite = data.favorite;
            cache.video = Object.values(videos);
        } else {
            const directory = cache.directories.find(i => i.videos.map(v => v.video.id.toString()).includes(id.toString()));
            const vids = keyBy(directory.videos, "video.id");
            if(vids[id]) {
                vids[id].user_stats.favorite = data.favorite;
                directory.videos = Object.values(vids);
                const other_directories = cache.directories.filter(i => !i.videos.map(v => v.video.id).includes(id));
                other_directories.push(directory);
                cache.directories = other_directories;
            }
        }
        saveCache();
        return [204];
    });

    mock.onGet(_endpoint(ENDPOINTS.BASE_VIDEO)).reply(config => {
        const params = config.params;
        const perPage = params.perPage || 2;
        const directory_videos = flattenDeep(cache.directories.map(i => i.videos.map(v => ({...v, directory: i}))));
        const all_videos = cache.video.concat(directory_videos);
        let base_videos = all_videos;
        let base_directories = cache.directories;
        if (params.categories.length) {
            base_videos = base_videos.filter(i => intersection(i.categories, params.categories).length > 0);
            base_directories = base_directories.filter(i => intersection(i.categories, params.categories).length > 0);
        }
        if (params.types.length) {
            // ???
        }
        if (params.search) {
            base_videos = base_videos.filter(i => i.video.title.toLowerCase().indexOf(params.search.toLowerCase()) > -1);
            base_directories = base_directories.filter(i => i.directory.title.toLowerCase().indexOf(params.search.toLowerCase()) > -1);
        }
        if (params.order_by) {
            // DO NOT WORK IN MOCKS
        }
        const data = {
            favorite_video: base_videos.filter(i => i.user_stats.favorite),
            directory_video: base_directories,
            video : base_videos.slice(params.page * perPage, params.page * perPage + perPage)
        }
        const metadata = {
            pages: base_videos.length / perPage,
            hasNext: base_videos.length / perPage > params.page + 1
        }
        return [200, {data, metadata}]
    })
    const getSingleVideoEndpoint = new RegExp(`${ENDPOINTS.BASE_VIDEO}/[0-9]+$`);
    mock.onGet(getSingleVideoEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_VIDEO, "").replace("/", "");
        const directory_videos = flattenDeep(cache.directories.map(i => i.videos.map(v => ({...v, directory: i}))));
        const all_videos = cache.video.concat(directory_videos);
        let video = keyBy(all_videos, "video.id")[id];
        if(!video) {
            return _buildError("video_not_found", 404);
        }
        return [200, video];
    });

    const singleVideoProgressEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_VIDEO}/[0-9]+/progress$`);
    mock.onPut(singleVideoProgressEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_VIDEO, "").replace("/progress", "").replace("/", "");
        const data = JSON.parse(config.data);
        const videos = keyBy(cache.video, "video.id");
        if(videos[id]) {
            videos[id].user_stats.current = data.current;
            cache.video = Object.values(videos);
        } else {
            const directory = cache.directories.find(i => i.videos.map(v => v.video.id.toString()).includes(id.toString()));
            const vids = keyBy(directory.videos, "video.id");
            if(vids[id]) {
                vids[id].user_stats.current = data.current;
                directory.videos = Object.values(vids);
                const other_directories = cache.directories.filter(i => !i.videos.map(v => v.video.id).includes(id));
                other_directories.push(directory);
                cache.directories = other_directories;
            }
        }
        saveCache();
        return [204];
    });

    const likeVideoEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_VIDEO}/-?[0-9]+${ENDPOINTS.LIKE}`);
    mock.onPut(likeVideoEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_VIDEO, "").replace(ENDPOINTS.LIKE, "").replace("/", "");
        const data = JSON.parse(config.data);
        const videos = keyBy(cache.video, "video.id");
        if(videos[id]) {
            videos[id].user_stats.liked = data.like;
            videos[id].likes = data.like ? videos[id].likes + 1 : videos[id].likes - 1;
            cache.video = Object.values(videos);
        } else {
            const directory = cache.directories.find(i => i.videos.map(v => v.video.id.toString()).includes(id.toString()));
            const vids = keyBy(directory.videos, "video.id");
            if(vids[id]) {
                vids[id].user_stats.liked = data.like;
                vids[id].likes = data.like ? vids[id].likes + 1 : vids[id].likes - 1;
                directory.videos = Object.values(vids);
                const other_directories = cache.directories.filter(i => !i.videos.map(v => v.video.id).includes(id));
                other_directories.push(directory);
                cache.directories = other_directories;
            }
        }
        saveCache();
        return [204];
    });
    mock.onPost(_endpoint(ENDPOINTS.USER_SEARCH)).reply(config => {
        const body = JSON.parse(config.data);
        const search = body.name.toLowerCase();
        const filtered = usersToSearch.filter(i => i.first_name.toLowerCase().includes(search) || i.last_name.toLowerCase().includes(search));
        return [200, filtered]
    });

    const commentVideoEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_VIDEO}/-?[0-9]+${ENDPOINTS.COMMENT}`);
    mock.onPost(commentVideoEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_VIDEO, "").replace(ENDPOINTS.COMMENT, "").replace("/", "");
        const data = JSON.parse(config.data);
        const generated_id = Math.floor(Math.random() * 10000);
        const usersObject = keyBy(usersToSearch, 'id');
        cache.comments.video[id] = {
            ...cache.comments.video[id],
            [generated_id]: {
                id: generated_id,
                comment: data.comment,
                tags: data.tags.map(i => ({
                    key: `@${usersObject[i].first_name} ${usersObject[i].last_name}`,
                    value: usersObject[i].slug,
                    id: usersObject[i].id
                })),
                user: {
                    avatar: "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg",
                    me: true,
                    name: "Test account",
                    role: "OWNER",
                    company: "Test srl"
                }
            }
        }
        saveCache();
        return [204];
    });
    const getCommentsEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_VIDEO}/-?[0-9]+${ENDPOINTS.COMMENT}`);
    mock.onGet(getCommentsEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_VIDEO, "").replace(ENDPOINTS.COMMENT, "").replace("/", "");
        const params = config.params;
        const perPage = params.perPage || 2;
        const comments = Object.values(cache.comments.video[id] || {})
        const metadata = {
            pages: comments.length / perPage,
            hasNext: comments.length / perPage > params.page + 1,
            totalItems: comments.length
        }
        const returnData = {
            comments: comments.slice(params.page * perPage, params.page * perPage + perPage),
            hasNextPage: metadata.hasNext,
            total: metadata.totalItems
        }
        return [200, returnData];
    });
    const deleteCommentVideoEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_VIDEO}/-?[0-9]+${ENDPOINTS.COMMENT}/[0-9]+$`);
    mock.onDelete(deleteCommentVideoEndpoint).reply(config => {
        const ids = config.url.replace(ENDPOINTS.BASE_VIDEO, "").replace(ENDPOINTS.COMMENT, "").replace("/", "");
        const [video_id, comment_id] = ids.split("/");
        delete cache.comments.video[video_id][comment_id];
        saveCache();
        return [204];
    });
    const editCommentVideoEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_VIDEO}/-?[0-9]+${ENDPOINTS.COMMENT}/[0-9]+$`);
    mock.onPut(editCommentVideoEndpoint).reply(config => {
        const ids = config.url.replace(ENDPOINTS.BASE_VIDEO, "").replace(ENDPOINTS.COMMENT, "").replace("/", "");
        const [id, comment_id] = ids.split("/");
        const data = JSON.parse(config.data);
        const usersObject = keyBy(usersToSearch, 'id');
        console.log(data);
        cache.comments.video[id] = {
            ...cache.comments.video[id],
            [comment_id]: {
                id: comment_id,
                comment: data.comment,
                tags: data.tags.map(i => ({
                    key: `@${usersObject[i].first_name} ${usersObject[i].last_name}`,
                    value: usersObject[i].slug,
                    id: usersObject[i].id
                })),
                user: {
                    avatar: "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg",
                    me: true,
                    first_name: "Test",
                    last_name: "Account",
                    role: "OWNER",
                    company_name: "Test srl"
                }
            }
        }
        saveCache();
        return [204];
    });
    const getSingleDirectoryEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_DIRECTORY}/-?[0-9]+$`);
    mock.onGet(getSingleDirectoryEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_DIRECTORY, "").replace("/", "");
        const directories = keyBy(cache.directories, "directory.id");
        return [200, directories[id]];
    });

    /* PAYMENT */
    const paySingleVideoEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_VIDEO}/-?[0-9]+${ENDPOINTS.UNLOCK}`);
    mock.onPost(paySingleVideoEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_VIDEO, "").replace(ENDPOINTS.UNLOCK, "").replace("/", "");
        const data = JSON.parse(config.data);
        if(!data.payment_method.card_id) {
            cache.profile.payment_methods.push(data.payment_method);
        }
        const videos = keyBy(cache.video, "video.id");
        if(videos[id]) {
            videos[id].unlocked.status = true;
            cache.video = Object.values(videos);
        } else {
            const directory = cache.directories.find(i => i.videos.map(v => v.video.id.toString()).includes(id.toString()));
            const vids = keyBy(directory.videos, "video.id");
            if(vids[id]) {
                vids[id].unlocked.status = true;
                directory.videos = Object.values(vids);
                const other_directories = cache.directories.filter(i => !i.videos.map(v => v.video.id).includes(id));
                other_directories.push(directory);
                cache.directories = other_directories;
            }
        }
        saveCache();
        return [204];
    });
    const paySingleDirectoryEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_DIRECTORY}/-?[0-9]+${ENDPOINTS.UNLOCK}`);
    mock.onPost(paySingleDirectoryEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_DIRECTORY, "").replace(ENDPOINTS.UNLOCK, "").replace("/", "");
        const directory = cache.directories.find(i => i.directory.id.toString() === id.toString());
        directory.unlocked.status = true;
        directory.videos = directory.videos.map( i => ({...i, unlocked: {status: true}}));
        saveCache();
        return [204];
    });
    mock.onPost(_endpoint(ENDPOINTS.ADD_PAYMENT_METHOD)).reply(config => {
        const data = JSON.parse(config.data);
        cache.profile.payment_methods.push(data.payment_method);
        saveCache();
        return [204]
    });

    mock.onPut(_endpoint(ENDPOINTS.EDIT_INVOICING)).reply(config => {
        const data = JSON.parse(config.data);
        cache.profile.invoicing = data.invoicing;
        saveCache();
        return [204];
    });
    mock.onGet(_endpoint(`${ENDPOINTS.BASE_VIDEO}${ENDPOINTS.SUGGESTED}`)).reply(config => {
        const {id} = config.params;
        return [200, cache.video.filter(i => i.video.id.toString() !== id.toString())]
    });
    mock.onGet(_endpoint(`${ENDPOINTS.BASE_DIRECTORY}${ENDPOINTS.SUGGESTED}`)).reply(config => {
        const {id} = config.params;
        return [200, cache.directories.filter(i => i.directory.id.toString() !== id.toString())]
    });
    mock.onGet(_endpoint(`${ENDPOINTS.BASE_EVENTS}${ENDPOINTS.SUGGESTED}`)).reply(config => {
        const {id} = config.params;
        return [200, cache.events.filter(i => i.id.toString() !== id.toString())]
    });

    mock.onGet(_endpoint(ENDPOINTS.SEARCH)).reply(config => {
        const {search} = config.params;
        const videos = cache.video.filter(i => i.video.title.toLowerCase().indexOf(search.toLowerCase()) > -1);
        const directories = cache.directories.filter(i => i.video.title.toLowerCase().indexOf(search.toLowerCase()) > -1);
        const data = [
            ...videos.map(i => ({type: "video", id: i.video.id, title: i.video.title})),
            ...directories.map(i => ({type: "directory", id: i.directory.id, title: i.directory.title}))
        ];
        return [200, data];
    });

    const favoriteEventEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_EVENTS}/-?[0-9]+${ENDPOINTS.FAVORITE}`);
    mock.onPut(favoriteEventEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_EVENTS, "").replace(ENDPOINTS.FAVORITE, "").replace("/", "");
        const data = JSON.parse(config.data);
        const events = keyBy(cache.events, "id");
        if(events[id]){
            events[id].favorite = data.favorite;
        }
        cache.events = Object.values(events);
        saveCache();
        return [204];
    });

    mock.onGet(_endpoint(ENDPOINTS.BASE_EVENTS)).reply(config => {
        const params = config.params;
        const perPage = params.perPage || 2;
        let base_events = cache.events;
        if (params.search) {
            base_events = base_events.filter(i => i.title.toLowerCase().indexOf(params.search.toLowerCase()) > -1);
        }
        const data = {
            favorite: base_events.filter(i => i.favorite),
            events : base_events.slice(params.page * perPage, params.page * perPage + perPage),
            old: [] //TODO ADD OLD EVENTS
        }
        const metadata = {
            pages: base_events.length / perPage,
            hasNext: base_events.length / perPage > params.page + 1
        }
        return [200, {data, metadata}]
    })
    const getSingleEventEndpoint = new RegExp(`${ENDPOINTS.BASE_EVENTS}/[0-9]+$`);
    mock.onGet(getSingleEventEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_EVENTS, "").replace("/", "");
        let event = keyBy(cache.events, "id")[id];
        if(!event) {
            return _buildError("video_not_found", 404);
        }
        return [200, event];
    });
    const likeEventEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_EVENTS}/-?[0-9]+${ENDPOINTS.LIKE}`);
    mock.onPut(likeEventEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_EVENTS, "").replace(ENDPOINTS.LIKE, "").replace("/", "");
        const data = JSON.parse(config.data);
        const events = keyBy(cache.events, "id");
        if(events[id]) {
            events[id].like = data.like;
            events[id].likes.total = data.like ? events[id].likes.total + 1 : events[id].likes.total - 1;
            cache.events = Object.values(events);
        }
        saveCache();
        return [204];
    });

    // EVENT COMMENTS
    const commentEventsEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_EVENTS}/-?[0-9]+${ENDPOINTS.COMMENT}`);
    mock.onPost(commentEventsEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_EVENTS, "").replace(ENDPOINTS.COMMENT, "").replace("/", "");
        const data = JSON.parse(config.data);
        const generated_id = Math.floor(Math.random() * 10000);
        const usersObject = keyBy(usersToSearch, 'id');
        cache.comments.events[id] = {
            ...cache.comments.events[id],
            [generated_id]: {
                id: generated_id,
                comment: data.comment,
                tags: data.tags.map(i => ({
                    key: `@${usersObject[i].first_name} ${usersObject[i].last_name}`,
                    value: usersObject[i].slug,
                    id: usersObject[i].id
                })),
                user: {
                    avatar: "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg",
                    me: true,
                    first_name: "Test",
                    last_name: "Account",
                    role: "OWNER",
                    company_name: "Test srl"
                }
            }
        }
        saveCache();
        return [204];
    });
    const getEventCommentsEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_EVENTS}/-?[0-9]+${ENDPOINTS.COMMENT}`);
    mock.onGet(getEventCommentsEndpoint).reply(config => {
        const id = config.url.replace(ENDPOINTS.BASE_EVENTS, "").replace(ENDPOINTS.COMMENT, "").replace("/", "");
        const params = config.params;
        const perPage = params.perPage || 2;
        const comments = Object.values(cache.comments.events[id] || {})
        const metadata = {
            pages: comments.length / perPage,
            hasNext: comments.length / perPage > params.page + 1,
            totalItems: comments.length
        }
        const returnData = {
            data: comments.slice(params.page * perPage, params.page * perPage + perPage),
            metadata
        }
        return [200, returnData];
    });
    const deleteCommentEventEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_EVENTS}/-?[0-9]+${ENDPOINTS.COMMENT}/[0-9]+$`);
    mock.onDelete(deleteCommentEventEndpoint).reply(config => {
        const ids = config.url.replace(ENDPOINTS.BASE_EVENTS, "").replace(ENDPOINTS.COMMENT, "").replace("/", "");
        const [id, comment_id] = ids.split("/");
        delete cache.comments.events[id][comment_id];
        saveCache();
        return [204];
    });
    const editCommentEventEndpoint = new RegExp(`${BASE_API_URL}${ENDPOINTS.BASE_EVENTS}/-?[0-9]+${ENDPOINTS.COMMENT}/[0-9]+$`);
    mock.onPut(editCommentEventEndpoint).reply(config => {
        const ids = config.url.replace(ENDPOINTS.BASE_EVENTS, "").replace(ENDPOINTS.COMMENT, "").replace("/", "");
        const [id, comment_id] = ids.split("/");
        const data = JSON.parse(config.data);
        const usersObject = keyBy(usersToSearch, 'id');
        cache.comments.events[id] = {
            ...cache.comments.events[id],
            [comment_id]: {
                id: comment_id,
                comment: data.comment,
                tags: data.tags.map(i => ({
                    key: `@${usersObject[i].first_name} ${usersObject[i].last_name}`,
                    value: usersObject[i].slug,
                    id: usersObject[i].id
                })),
                user: {
                    avatar: "https://mymodernmet.com/wp/wp-content/uploads/2019/09/100k-ai-faces-6.jpg",
                    me: true,
                    first_name: "Test",
                    last_name: "Account",
                    role: "OWNER",
                    company_name: "Test srl"
                }
            }
        }
        saveCache();
        return [204];
    });


    mock.onAny().reply((config) => {
        console.log(config.method, config.url);
        return _buildError("not_found", 404);
    });
}


function update(data, keys, value) {
    if (keys.length === 0) {
        // Leaf node
        return value;
    }

    let key = keys.shift();
    if (!key) {
        data = data || [];
        if (Array.isArray(data)) {
            key = data.length;
        }
    }

    // Try converting key to a numeric value
    let index = +key;
    if (!isNaN(index)) {
        // We have a numeric index, make data a numeric array
        // This will not work if this is a associative array
        // with numeric keys
        data = data || [];
        key = index;
    }
    // If none of the above matched, we have an associative array
    data = data || {};

    data[key] = update(data[key], keys, value);
    return data;
}

function serializeForm(form) {
    return Array.from(form.entries())
        .reduce((data, [field, value]) => {
            // eslint-disable-next-line no-unused-vars
            let [_, prefix, keys] = field.match(/^([^[]+)((?:\[[^\]]*])*)/);

            if (keys) {
                keys = Array.from(keys.matchAll(/\[([^\]]*)]/g), m => m[1]);
                value = update(data[prefix], keys, value);
            }
            data[prefix] = value;
            return data;
        }, {});
}